export default __webpack_public_path__ + "static/media/lock-new.e6c9f690.svg";